import { addOnSchema } from './add-on';
import { z } from 'zod/v4';

export const productLicenseSummarySchema = z.object({
  productId: z.number(),
  productName: z.string(),
  addons: z.array(addOnSchema).nullable().optional(),
  totalActivatedLicenses: z.number(),
  totalAllocatedLicenses: z.number(),
  totalAssignedLicenses: z.number(),
  isActive: z.boolean(),
});

export type ProductLicenseSummary = z.infer<typeof productLicenseSummarySchema>;
